import { motion } from "framer-motion";

export const REGIONS = [
  { id: "turkiye", label: "Türkiye", x: 560, y: 205, hub: true },
  { id: "europe", label: "Europe", x: 462, y: 150 },
  { id: "iraq", label: "Iraq", x: 602, y: 222 },
  { id: "middle-east", label: "Middle East", x: 626, y: 252 },
  { id: "gcc", label: "GCC Countries", x: 652, y: 276 },
  { id: "central-asia", label: "Central Asia", x: 702, y: 182 },
  { id: "south-asia", label: "South Asia", x: 748, y: 258 },
  { id: "east-asia", label: "East Asia", x: 842, y: 214 },
  { id: "africa", label: "Africa", x: 548, y: 336 },
];

const HUB = REGIONS.find((r) => r.hub);
const SPOKES = REGIONS.filter((r) => !r.hub);

export default function GlobalMap({ active, onHover }) {
  return (
    <svg
      viewBox="0 0 1000 520"
      className="w-full h-full"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="global-map"
    >
      {/* stylised continents */}
      <g fill="#C5A059" opacity="0.08">
        <path d="M110,150 Q150,90 235,105 Q300,115 330,160 Q340,205 315,240 Q280,268 225,262 Q165,255 140,225 Q105,195 110,150 Z" />
        <path d="M260,295 Q290,278 320,300 Q338,345 322,400 Q300,438 278,430 Q256,408 258,362 Q252,320 260,295 Z" />
        <path d="M440,128 Q505,105 565,138 Q588,165 566,188 Q515,205 470,190 Q432,165 440,128 Z" />
        <path d="M505,205 Q568,210 592,268 Q598,345 562,398 Q528,425 505,402 Q485,352 480,285 Q490,225 505,205 Z" />
        <path d="M595,200 Q640,198 668,228 Q674,268 645,286 Q612,286 595,262 Q582,228 595,200 Z" />
        <path d="M660,120 Q750,102 840,132 Q895,165 895,220 Q878,270 815,270 Q748,270 705,242 Q656,208 660,158 Q656,138 660,120 Z" />
        <path d="M820,278 Q865,282 888,315 Q878,352 832,362 Q800,352 800,314 Q800,288 820,278 Z" />
        <path d="M860,388 Q892,382 908,410 Q898,432 870,432 Q843,426 848,404 Q853,390 860,388 Z" />
      </g>

      {/* connection lines */}
      {SPOKES.map((p, i) => {
        const mx = (HUB.x + p.x) / 2;
        const my = Math.min(HUB.y, p.y) - 42;
        const isOn = active === p.id || active === "turkiye" || !active;
        return (
          <motion.path
            key={`line-${p.id}`}
            d={`M ${HUB.x} ${HUB.y} Q ${mx} ${my} ${p.x} ${p.y}`}
            stroke="#C5A059"
            strokeWidth={active === p.id ? 1.6 : 1}
            fill="none"
            strokeDasharray="3 5"
            initial={{ pathLength: 0, opacity: 0 }}
            whileInView={{ pathLength: 1, opacity: isOn ? 0.7 : 0.18 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.4, delay: 0.15 + i * 0.12, ease: "easeInOut" }}
          />
        );
      })}

      {/* hub */}
      <motion.g
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
        style={{ transformOrigin: `${HUB.x}px ${HUB.y}px` }}
        onMouseEnter={() => onHover && onHover("turkiye")}
        onMouseLeave={() => onHover && onHover(null)}
        className="cursor-pointer"
      >
        <motion.circle
          cx={HUB.x}
          cy={HUB.y}
          r="14"
          fill="#C5A059"
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          initial={{ scale: 0.9, opacity: 0.16 }}
          animate={{ scale: [0.9, 1.6, 0.9], opacity: [0.16, 0.04, 0.16] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />
        <circle cx={HUB.x} cy={HUB.y} r="8" fill="#C5A059" opacity="0.35" />
        <circle cx={HUB.x} cy={HUB.y} r="4.5" fill="#C5A059" />
        <text
          x={HUB.x + 14}
          y={HUB.y - 12}
          fill="#FDFBF7"
          fontSize="16"
          fontFamily="Cormorant Garamond, serif"
          fontStyle="italic"
        >
          {HUB.label}
        </text>
      </motion.g>

      {/* spokes */}
      {SPOKES.map((p, i) => {
        const on = active === p.id;
        return (
          <motion.g
            key={p.id}
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.4, delay: 1.2 + i * 0.09 }}
            style={{ transformOrigin: `${p.x}px ${p.y}px` }}
            onMouseEnter={() => onHover && onHover(p.id)}
            onMouseLeave={() => onHover && onHover(null)}
            className="cursor-pointer"
          >
            <circle
              cx={p.x}
              cy={p.y}
              r={on ? 10 : 6}
              fill="#C5A059"
              opacity={on ? 0.25 : 0.16}
              style={{ transition: "all 0.25s" }}
            />
            <circle cx={p.x} cy={p.y} r={on ? 4 : 3} fill="#C5A059" />
            <text
              x={p.x + 9}
              y={p.y - 8}
              fill={on ? "#C5A059" : "rgba(255,255,255,0.72)"}
              fontSize="11"
              fontFamily="Outfit, sans-serif"
              letterSpacing="0.08em"
              style={{ transition: "fill 0.25s" }}
            >
              {p.label.toUpperCase()}
            </text>
          </motion.g>
        );
      })}
    </svg>
  );
}
